/* Demo gallery tabs. The component owns both the tab row and the grid, so the
   markup can move without breaking the wiring. Filtering is delegated from the
   tab row rather than bound per button, so tabs added by the editor still work. */
if (!customElements.get('demo-card-filter')) {
  customElements.define(
    'demo-card-filter',
    class DemoCardFilter extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.tablist = this.querySelector('[role="tablist"]');
        if (!this.tablist) return;
        this.initialized = true;

        this.tablist.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-filter]');
          if (tab) this.select(tab);
        });

        this.tablist.addEventListener('keydown', (event) => {
          const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          const tabs = this.tabs();
          const i = tabs.indexOf(document.activeElement);
          let next = i;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          this.select(tabs[next]);
          tabs[next].focus();
        });
      }

      tabs() {
        return Array.from(this.tablist.querySelectorAll('[data-filter]'));
      }

      cards() {
        return Array.from(this.querySelectorAll('[data-category]'));
      }

      select(activeTab) {
        if (!activeTab) return;
        const value = activeTab.dataset.filter;
        this.tabs().forEach((tab) => {
          const on = tab === activeTab;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
        });
        this.cards().forEach((card) => {
          card.toggleAttribute('hidden', !(value === 'all' || card.dataset.category === value));
        });
      }

      reveal(card) {
        const all = this.querySelector('[data-filter="all"]');
        if (all) return this.select(all);
        const owner = this.querySelector(`[data-filter="${card.dataset.category}"]`);
        this.select(owner);
      }
    }
  );
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('demo-card-filter').forEach((el) => el.connectedCallback());
});

// editor: selecting a card should reveal it even when it sits under a narrower tab
document.addEventListener('shopify:block:select', (event) => {
  const root = event.target.closest('demo-card-filter');
  const card = event.target.closest('[data-category]');
  if (root && root.reveal && card) root.reveal(card);
});
